import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import Ghost from "./Ghost";

export default function Story() {
  const reduced = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [reduced ? 0 : 100, reduced ? 0 : -100]);

  return (
    <section
      id="historia"
      ref={ref}
      className="relative py-28 md:py-40 bg-gradient-to-b from-[#E0F2FE]/40 to-[#F4FAFF]"
      data-testid="story-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 grid grid-cols-12 gap-8 items-center">
        <motion.div
          style={{ y }}
          className="col-span-12 md:col-span-5 flex justify-center"
          data-testid="story-ghost"
        >
          <motion.div
            animate={reduced ? undefined : { y: [-10, 10, -10] }}
            transition={reduced ? undefined : { duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
          >
            <Ghost size={280} />
          </motion.div>
        </motion.div>

        <div className="col-span-12 md:col-span-7">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="chip"
          >
            <span className="dot" /> Historia
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="font-display font-semibold text-[#051937] text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05] tracking-tight"
          >
            Zaczęło się od kartki, ołówka i{" "}
            <span className="font-script text-[#60A5FA]">jednej ciepłej nocy.</span>
          </motion.h2>

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            variants={{
              hidden: {},
              show: { transition: { staggerChildren: 0.15 } },
            }}
            className="mt-10 space-y-6 text-lg leading-relaxed text-[#0b2a55]/85 max-w-xl"
          >
            {[
              "Tworzymy przygody Tonka i Duszka dla dzieci, które boją się ciemności, ale wciąż zaglądają pod łóżko.",
              "Nasze bajki wydrukowane są na papierze z recyklingu, a każdy egzemplarz ma miejsce, w które dziecko może wpisać swoje imię.",
              "Wierzymy, że bycie odważnym to nie brak strachu — to zapraszanie go na herbatę.",
            ].map((t, i) => (
              <motion.p
                key={i}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.8 } },
                }}
              >
                {t}
              </motion.p>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
